import { render, staticRenderFns } from "./ProductEditor.vue?vue&type=template&id=4d3b6b86&scoped=true"
import script from "./ProductEditor.vue?vue&type=script&lang=js"
export * from "./ProductEditor.vue?vue&type=script&lang=js"
import style0 from "./ProductEditor.vue?vue&type=style&index=0&id=4d3b6b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3b6b86",
  null
  
)

export default component.exports